module.exports = __webpack_public_path__ + "static/media/abstrato-1.d27513af.jpg";